import React, {PropsWithChildren} from "react";
import {CssBaseline, makeStyles, Theme} from '@material-ui/core';
import PageHeader from "./common/PageHeader";
import DesktopFallbackDialog from "../components/core/DesktopFallbackDialog";


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flex: 1
    },
    content: {
        flexGrow: 1
    }
}));

type PublicLayoutProps = {
    pageTitle?: string
};


export const PublicLayout: React.FC<PropsWithChildren<PublicLayoutProps>> = ({pageTitle, children}) => {
    const classes = useStyles();

    return (<div className={classes.root}>
            <CssBaseline/>
            <PageHeader pageTitle={pageTitle}/>
            <main
                className={classes.content}
            >
                {children}
            </main>
            <DesktopFallbackDialog/>
        </div>
    );
};

export default PublicLayout;
